<template>
  <div>
    <div class="pl-2 mt-5">
      <router-link
        :to="{ path: '/dashboard' }"
        style="text-decoration: none; color: #7986cb"
      >
        <v-icon color="#7986cb">mdi-arrow-left</v-icon
        ><span>Back to Portfolio Overview</span></router-link
      >
    </div>
    <div v-show="displayRadar">
      <v-select
        style="width: 250px; margin: auto"
        v-model="selectedDomainMetric"
        :items="options"
        label="Domain criteria metric"
        item-text="label"
        item-value="value"
        outlined
        dense
      ></v-select>
      <radar-chart :series="series" :categories="categories" />
    </div>

    <div
      style="
        height: 500px;
        width: 500px;
        color: gray;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
      "
      class="text-center mt-10 pt-10"
      v-show="!displayRadar"
    >
      <h4>There is no SRI scores data for selected functional units</h4>
    </div>
  </div>
</template>

<script>
import RadarChart from "../components/RadarChart.vue";
import services from "../rest/Services";

export default {
  name: "Building",

  components: {
    RadarChart,
  },
  data: function () {
    return {
      selectedDomainMetric: "COOLING",
      options: [
        { value: "COOLING", label: "Cooling" },
        {
          value: "DOMESTIC_HOT_WATER",
          label: "Domestic hot water",
        },
        {
          value: "DYNAMIC_BUILDING_ENVELOPE",
          label: "Dynamic building envelope",
        },
        { value: "ELECTRICITY", label: "Electricity" },
        {
          value: "ELECTRIC_VEHICLE_CHARGING",
          label: "Electric vehicle charging",
        },
        {
          value: "HEATING",
          label: "Heating",
        },
        { value: "LIGHTING", label: "Lighting" },
        { value: "MONITORING_AND_CONTROL", label: "Monitoring and control" },
        { value: "VENTILATION", label: "Ventilation" },
      ],

      selectedIds: null,
      series: [],
      categories: [
        "ENERGY_EFFICIENCY",
        "ENERGY_FLEXIBILITY_AND_STORAGE",
        "INFORMATION_TO_OCCUPANTS",
        "COMFORT",
        "MAINTENANCE_AND_FAULT_PREDICTION",
        "HEALTH_WELL_BEING_AND_ACCESSIBILITY",
        "CONVENIENCE",
      ],

      functionalUnits: null,
      displayRadar: true,
    };
  },
  methods: {
    createSeries: function () {
      this.series.length = 0;
      this.functionalUnits.forEach((funit) => {
        if (funit.score) {
          this.series.push({
            name:
              funit.functional_unit.address_data.street +
              " " +
              funit.functional_unit.address_data.street_number +
              ", " +
              funit.functional_unit.address_data.city +
              ", " +
              funit.functional_unit.address_data.country,
            data: this.createSeriesFromScores(funit),
            pointPlacement: "on",
            opacity: 0.5,
          });
        }
      });
    },
    createSeriesFromScores(funit) {
      let series = [];
      this.categories.forEach((category) => {
        if (funit.score) {
          series.push(
            Math.round(
              funit.score.impact_domain_scores[category][
                this.selectedDomainMetric
              ] * 100
            )
          );
        }
      });
      return series;
    },
    checkIfAllHaveScores() {
      return this.functionalUnits.some((fUnit) => fUnit.score);
    },
  },
  watch: {
    "$route.params.ids": {
      handler(ids) {
        if (ids) {
          this.selectedIds = ids.split(",").map(Number);
          let body = {
            functional_unit_ids: this.selectedIds,
          };
          services
            .getFunctionalUnitsWithDetailedScores(body)
            .then((response) => {
              this.functionalUnits = response.data.functional_units;
              if (this.checkIfAllHaveScores()) {
                this.displayRadar = true;
                this.createSeries();
              } else this.displayRadar = false;
            })
            .catch((error) => {
              console.log(error);
            });
        }
      },
      immediate: true, // Execute the handler immediately on component initialization
    },
    selectedDomainMetric: function () {
      this.createSeries();
    },
  },
};
</script>

<style scoped>
.building-form {
  margin: auto;
  margin-top: 3em;
}
</style>
